import { render, staticRenderFns } from "./FlexmesasgeFolderItem.vue?vue&type=template&id=9b8f1898&scoped=true&"
import script from "./FlexmesasgeFolderItem.vue?vue&type=script&lang=js&"
export * from "./FlexmesasgeFolderItem.vue?vue&type=script&lang=js&"
import style0 from "./FlexmesasgeFolderItem.vue?vue&type=style&index=0&id=9b8f1898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8f1898",
  null
  
)

export default component.exports